
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://zvkuugzmrjqyewhlpwig.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2a3V1Z3ptcmpxeWV3aGxwd2lnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzAxMjY3NzYsImV4cCI6MjA0NTcwMjc3Nn0.chgZuz_aTayqxpf0UAVARtW7JmPscP0nTG0ayApoAF0';

const supabase = createClient(supabaseUrl, supabaseKey);

export { supabase };